import React from 'react';
import '../../styles/SolucionesPublicitarias.css';
import cardsData from '../../data/displayMobile.json';


const DisplayMobile = () => {
    return (
        <section className="display-mobile-section py-5">
            <div className="container">

                <div className="title-container" data-aos="fade-up">
                    <h2 className="title">Mobile</h2>
                    <div className="title-underline"></div>
                </div>

                <div className='row align-items-start'>
                    {cardsData.map((card, index) => (
                        <div
                            key={index}
                            className='col-lg-4 col-md-6 display-mobile-card justify-content-center align-items-center mt-5 mb-5'
                        >
                            <div className='img-display-mobile' data-aos="flip-right">
                                <img src={card.img} className='img-fluid img-filter' alt={card.title} />
                            </div>
                            <div data-aos="fade-up">
                                <h4 >{card.title}</h4>
                                <p >{card.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DisplayMobile;